module.exports = __webpack_public_path__ + "img/confirm-btn_yes.ebd5996e.png";